var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "error-page" },
    [
      _vm.authenticated ? _c("app-header") : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "content" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }